import type { LanguageCode } from '@/types/language';

interface TypeTranslations {
  [key: string]: {
    en: string;
    'de-DE': string;
    'zh-Hans': string;
  };
}

export const typeTranslations: TypeTranslations = {
  expert: { en: 'Expert', 'de-DE': 'Experte', 'zh-Hans': '专家' },
  course: { en: 'Live Course', 'de-DE': 'Live-Kurs', 'zh-Hans': '课程' },
  partner: { en: 'Partner', 'de-DE': 'Partner', 'zh-Hans': '合作伙伴' },
  therapist_session: {
    en: 'Therapist Session',
    'de-DE': 'EinzelGespräch mit expert:in',
    'zh-Hans': '治疗会议',
  },
};

export const getTranslatedType = (type: string, language: LanguageCode): string => {
  return typeTranslations[type]?.[language] || typeTranslations[type]?.en || type;
};

export const languageTranslations: { [key: string]: { [locale: string]: string } } = {
  Arabisch: {
    en: 'Arabic',
    'de-DE': 'Arabisch',
    'zh-Hans': '阿拉伯语',
  },
  Bengali: {
    en: 'Bengali',
    'de-DE': 'Bengalisch',
    'zh-Hans': '孟加拉语',
  },
  Bosnisch: {
    en: 'Bosnian',
    'de-DE': 'Bosnisch',
    'zh-Hans': '波斯尼亚语',
  },
  Bulgarisch: {
    en: 'Bulgarian',
    'de-DE': 'Bulgarisch',
    'zh-Hans': '保加利亚语',
  },
  Chinesisch: {
    en: 'Chinese',
    'de-DE': 'Chinesisch',
    'zh-Hans': '中文',
  },
  Deutsch: {
    en: 'German',
    'de-DE': 'Deutsch',
    'zh-Hans': '德语',
  },
  Englisch: {
    en: 'English',
    'de-DE': 'Englisch',
    'zh-Hans': '英语',
  },
  Französisch: {
    en: 'French',
    'de-DE': 'Französisch',
    'zh-Hans': '法语',
  },
  Griechisch: {
    en: 'Greek',
    'de-DE': 'Griechisch',
    'zh-Hans': '希腊语',
  },
  Hindi: {
    en: 'Hindi',
    'de-DE': 'Hindi',
    'zh-Hans': '印地语',
  },
  Italienisch: {
    en: 'Italian',
    'de-DE': 'Italienisch',
    'zh-Hans': '意大利语',
  },
  Japanisch: {
    en: 'Japanese',
    'de-DE': 'Japanisch',
    'zh-Hans': '日语',
  },
  Koreanisch: {
    en: 'Korean',
    'de-DE': 'Koreanisch',
    'zh-Hans': '韩语',
  },
  Kroatisch: {
    en: 'Croatian',
    'de-DE': 'Kroatisch',
    'zh-Hans': '克罗地亚语',
  },
  Mandarin: {
    en: 'Mandarin',
    'de-DE': 'Mandarin',
    'zh-Hans': '普通话',
  },
  Mazedonisch: {
    en: 'Macedonian',
    'de-DE': 'Mazedonisch',
    'zh-Hans': '马其顿语',
  },
  Niederländisch: {
    en: 'Dutch',
    'de-DE': 'Niederländisch',
    'zh-Hans': '荷兰语',
  },
  Polnisch: {
    en: 'Polish',
    'de-DE': 'Polnisch',
    'zh-Hans': '波兰语',
  },
  Portugiesisch: {
    en: 'Portuguese',
    'de-DE': 'Portugiesisch',
    'zh-Hans': '葡萄牙语',
  },
  Rumänisch: {
    en: 'Romanian',
    'de-DE': 'Rumänisch',
    'zh-Hans': '罗马尼亚语',
  },
  Russisch: {
    en: 'Russian',
    'de-DE': 'Russisch',
    'zh-Hans': '俄语',
  },
  Serbisch: {
    en: 'Serbian',
    'de-DE': 'Serbisch',
    'zh-Hans': '塞尔维亚语',
  },
  Spanisch: {
    en: 'Spanish',
    'de-DE': 'Spanisch',
    'zh-Hans': '西班牙语',
  },
  Tamil: {
    en: 'Tamil',
    'de-DE': 'Tamil',
    'zh-Hans': '泰米尔语',
  },
  Telugu: {
    en: 'Telugu',
    'de-DE': 'Telugu',
    'zh-Hans': '泰卢固语',
  },
  Türkisch: {
    en: 'Turkish',
    'de-DE': 'Türkisch',
    'zh-Hans': '土耳其语',
  },
  Ukrainisch: {
    en: 'Ukrainian',
    'de-DE': 'Ukrainisch',
    'zh-Hans': '乌克兰语',
  },
  Vietnamesisch: {
    en: 'Vietnamese',
    'de-DE': 'Vietnamesisch',
    'zh-Hans': '越南语',
  },
  Ungarisch: {
    en: 'Hungarian',
    'de-DE': 'Ungarisch',
    'zh-Hans': '匈牙利语',
  },
};
